import { Component, inject, signal, ViewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyStickyFooterModule } from '@vendasta/galaxy/sticky-footer';
import { map, of } from 'rxjs';
import { SMSI18NModule } from '../../../assets/i18n/sms-i18n.module';
import { SmsInjectionToken } from '../../../token';
import { RegistrationStage } from '../a2p-registration.constants';
import { A2PRegistrationService } from '../a2p-registration.service';
import { InfoBannerComponent } from '../info-banner/info-banner.component';
import { SmsRegistrationErrorBannerComponent } from '../sms-registration-error-banner/sms-registration-error-banner.component';
import { SmsRegistrationFormComponent } from '../sms-registration-form/sms-registration-form.component';

@Component({
  selector: 'sms-registration',
  imports: [
    GalaxyAlertModule,
    GalaxyStickyFooterModule,
    InfoBannerComponent,
    MatButtonModule,
    MatIconModule,
    SMSI18NModule,
    SmsRegistrationErrorBannerComponent,
    SmsRegistrationFormComponent,
    TranslateModule,
  ],
  templateUrl: './sms-registration.component.html',
  styleUrls: ['./sms-registration.component.scss'],
})
export class SmsRegistrationComponent {
  private smsRegistrationService = inject(A2PRegistrationService);
  private smsDeps = inject(SmsInjectionToken);

  readonly showDetails = signal(true);
  readonly canSubmit = toSignal(
    this.smsRegistrationService.registrationStage$.pipe(
      map(
        (stage) =>
          stage === RegistrationStage.NotSubmitted ||
          stage === RegistrationStage.DataError ||
          stage === RegistrationStage.CampaignError,
      ),
    ),
    { initialValue: false },
  );
  readonly isCampaignError = toSignal(
    this.smsRegistrationService.registrationStage$.pipe(map((stage) => stage === RegistrationStage.CampaignError)),
    { initialValue: false },
  );
  readonly isA2pSubmitRestricted = toSignal(this.smsDeps.isA2pSubmitRestricted$ ?? of(false), { initialValue: false });

  @ViewChild(SmsRegistrationFormComponent) formComponent!: SmsRegistrationFormComponent;

  submitRegistration(): void {
    this.formComponent.submitRegistrationForm();
  }

  saveChanges(): void {
    this.formComponent.saveChanges();
  }
}
